import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import DigitalConcierge from '../DigitalConcierge';

/**
 * Layout component that wraps public pages.
 * Uses Outlet for nested route rendering to prevent remounting.
 */
export const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <DigitalConcierge />
        </div>
    );
};

export default Layout;
